import React from 'react'

export const Events = () => {
  return (
    <div>Events</div>
  )
}
